/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Napkin',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 1.40039C21.8837 1.40039 22.5996 2.11634 22.5996 3V21C22.5996 21.8837 21.8837 22.5996 21 22.5996H3C2.11634 22.5996 1.40039 21.8837 1.40039 21V3C1.40039 2.11634 2.11634 1.40039 3 1.40039H21ZM12.5996 11C12.5996 11.8837 11.8837 12.5996 11 12.5996H2.59961V21C2.59961 21.2209 2.77909 21.4004 3 21.4004H21C21.2209 21.4004 21.4004 21.2209 21.4004 21V3C21.4004 2.77909 21.2209 2.59961 21 2.59961H12.5996V11ZM3.44727 11.4004H11C11.2209 11.4004 11.4004 11.2209 11.4004 11V3.44727L3.44727 11.4004ZM3 2.59961C2.77909 2.59961 2.59961 2.77909 2.59961 3V10.5527L10.5527 2.59961H3Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.75 3.375C43.7855 3.375 44.625 4.21447 44.625 5.25V42.75C44.625 43.7855 43.7855 44.625 42.75 44.625H5.25C4.21447 44.625 3.375 43.7855 3.375 42.75V5.25C3.375 4.21447 4.21447 3.375 5.25 3.375H42.75ZM24.625 22.75C24.625 23.7855 23.7855 24.625 22.75 24.625H4.625V42.75C4.625 43.0952 4.90482 43.375 5.25 43.375H42.75C43.0952 43.375 43.375 43.0952 43.375 42.75V5.25C43.375 4.90482 43.0952 4.625 42.75 4.625H24.625V22.75ZM5.50977 23.375H22.75C23.0952 23.375 23.375 23.0952 23.375 22.75V5.50977L5.50977 23.375ZM5.25 4.625C4.90482 4.625 4.625 4.90482 4.625 5.25V22.4902L22.4902 4.625H5.25Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
